import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import AdvancedCombobox from "../../../primer/AdvancedCombobox";
import {
    resetNewVisit, setAutoPatientHistory,
    setNewVisit, setNewVisitOverrideModal,
    setNewVisitSelectedClient
} from "../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import Button from "react-bootstrap/Button";
import Input from "../../../common/Input";
import {checkPermission, isEmpty} from "../../../../_helpers/commonFunctions";
import TextArea from "../../../common/TextArea";
import {setSaveNewVisit} from "../../../../_reducers/activitySlice";
import {checkForActiveVisit, postNewVisit} from "../../../../_apis/api";
import moment from "moment";
import "./styles.css";
import NewClientModal from "../Clients/new-client-modal";
import BiometricsModal from "./Components/biometricsModal";
import {fetchPatientDetails} from "../Clients/clientHelpers";
import Modal from "react-bootstrap/Modal";
import {asArray, linkify, newVisitOverrideOptions} from "./constants";
import Dropdown from "../../../primer/Dropdown";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {toast} from "react-toastify";
import Alert from "react-bootstrap/Alert";
import PatientDetailsModal from "./Components/patientDetailsModal";
import VisitContactPoints from "./Components/visitContactPoints";
import {openClient, openTabByType} from "../../../../_helpers/tabOpeners";

const VisitNew = () => {
    const dispatch = useDispatch();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const saveNewVisit = useSelector((state) => state.ACTIVITY.saveNewVisit);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const newVisit = useSelector((state) => state.PRESCRIPTION.newVisit);
    const newVisitSelectedClient = useSelector((state) => state.PRESCRIPTION.newVisitSelectedClient);
    const newVisitOverrideModal = useSelector((state) => state.PRESCRIPTION.newVisitOverrideModal);
    const [patientsList, setPatientsList] = useState([]);

    const [showBiometrics, setShowBiometrics] = useState(false);
    const [showPatientDetails, setShowPatientDetails] = useState(false);
    const [loadingCheck, setLoadingCheck] = useState(false);

    const [patientNotifications, setPatientNotifications] = useState([]);
    const [patientNotificationsModal, setPatientNotificationsModal] = useState(false);

    const [loadingPostWithOverride, setLoadingPostWithOverride] = useState(false);

    const patientDropdownColumns = [
        {
            label: "Ονοματεπώνυμο",
            name: "name",
        },
        {
            label: "AMKA",
            name: "amka",
        },
    ]

    useEffect(() => {
        loadPatientsList(null, setPatientsList);
        dispatch(checkForActiveVisit(company, TABS_DATA, setLoadingCheck));
    }, [])

    const loadPatientsList = (keyword, setData) => {
        let reqData = {
            company: company.id,
        }
        if (keyword) reqData.keyword = keyword;
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/list-patients`, {
            headers: { "Content-Type": "application/json" },
            params: reqData
        }).then((res) => {
            if (res.data.status === "200") {
                if (typeof setData === "function") setData(res.data.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const handleOnChange = (e, type, name) => {
        if (!saveNewVisit) dispatch(setSaveNewVisit(true));

        if (type === "acdd") {
            if (name === "clientName") {
                fetchPatientDetails(e.row.amka, company.id).then((patientData) => {
                    let arr = [];
                    let prepChange = {};
                    if (patientData.success) {
                        let activeInsurances = [];
                        let activePartException = {};
                        let ekasLoss = "false";
                        if (patientData.data.message) arr.push(patientData.data.message);
                        if (patientData.data.covidVaccineMessage) arr.push(patientData.data.covidVaccineMessage);
                        if (patientData.data.noPaperConstent === "true") prepChange.noPaperConstent = "true";
                        if (patientData.data.activeInsurances.activeInsurance) {
                            activeInsurances = asArray(patientData.data.activeInsurances.activeInsurance);
                            if (activeInsurances.length > 0) activeInsurances[0].erp_selected = true;
                        }
                        if (patientData.data.ekasLoss === "true") ekasLoss = "true";
                        if (patientData.data?.patientPartExceptions?.patientPartExceptions) {
                            let activePartExceptions = asArray(patientData.data.patientPartExceptions.patientPartExceptions);
                            activePartExceptions = activePartExceptions.filter((el) => isEmpty(el.effectiveTo)
                                || (!isEmpty(el.effectiveTo) && moment(el.effectiveTo, "YYYY-MM-DD").endOf("day") > moment()));
                            if (activePartExceptions.length > 0) activePartException = activePartExceptions[0];
                        }

                        if (arr.length > 0) setPatientNotificationsModal(true);
                        setPatientNotifications(arr);

                        dispatch(setNewVisit({
                            ...newVisit,
                            client: e.row._id,
                            clientName: e.row.name,
                            activeInsurances: activeInsurances,
                            ekasLoss: ekasLoss,
                            activePartException: activePartException,
                        }));
                        dispatch(setNewVisitSelectedClient({...patientData.clientData, ...prepChange, patientData: patientData.data}));
                    } else {
                        toast.error("Σφάλμα κατά την άντληση δεδομένων ασθενή. Παρακαλώ ξαναδοκιμάστε.");
                    }
                });
            }
        } else if (type === "textarea") {
            dispatch(setNewVisit({...newVisit, [name]: e.target.value}));
        }
    }

    const handleResetNewVisit = () => {
        dispatch(resetNewVisit());
    }

    const hookNewPatient = async (data) => {
        handleOnChange({row: data}, "acdd", "clientName");
    }

    const handleCloseOverrideModal = () => {
        if (!loadingPostWithOverride) {
            dispatch(setNewVisitOverrideModal({
                show: false,
                text: "",
                overrideTypeId: "",
                overrideReasonId: "",
                isChecked: "",
            }))
        } else {
            toast.info("Παρακαλώ περιμένετε...");
        }
    }

    const handleSaveWithOverrides = () => {
        if (isEmpty(newVisitOverrideModal.overrideReasonId)) {
            return toast.warning("Παρακαλώ επιλέξτε λόγο εξαίρεσης.");
        } else if (newVisitOverrideModal.isChecked !== "true") {
            return toast.warning("Για να ολοκληρωθεί η καταχώριση επίσκεψης πρέπει να γίνει αποδοχή της εξαίρεσης.");
        }
        const postData = {...newVisit, selectedClient: newVisitSelectedClient, company: company.id, overrides: newVisitOverrideModal};
        dispatch(postNewVisit(postData, setLoadingPostWithOverride, company, TABS_DATA, handleCloseOverrideModal));
    }

    const handleSelectInsurance = (idx) => {
        if (!saveNewVisit) dispatch(setSaveNewVisit(true));
        const cloneInsurances = structuredClone(newVisit.activeInsurances);
        cloneInsurances.forEach((ins) => {
            ins.erp_selected = false;
        })
        cloneInsurances[idx].erp_selected = true;
        dispatch(setNewVisit({...newVisit, activeInsurances: cloneInsurances}));
    }

    const handleOpenPatientHistory = () => {
        axios.get(process.env.REACT_APP_API_URL2 + `/client/get-client-id-by/${newVisit.client}`, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setAutoPatientHistory(res.data.data));
                dispatch(openTabByType("patient-history", TABS_DATA));
            } else {
                toast.error("Σφάλμα κατά την άντληση ασθενή.");
            }
        }).catch((error) => {
            console.log(error);
            toast.error("Σφάλμα κατά την άντληση ασθενή.");
        })
    }

    const handleOpenPatientCloud = () => {
        openClient(dispatch, TABS_DATA, company.id, newVisit.client, 8);
    }

    const patientSelected = String(newVisit.client).length === 24;

    return (
        <React.Fragment>
            {loadingCheck ? (
                <React.Fragment>
                    <Row className={"mb-3"}>
                        <Col md={12} className={"d-flex justify-content-center"}>
                            Παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                        </Col>
                    </Row>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Row className={"mb-3"}>
                        <Col md={5}>
                            <Row>
                                <Col md={11}>
                                    <AdvancedCombobox
                                        name={"clientName"}
                                        className={"w-100 ac-select-dropdown"}
                                        defaultValue={`${newVisit.clientName}${newVisitSelectedClient.amka ? ` (${newVisitSelectedClient.amka})` : ""}`}
                                        label={"Ασθενής"}
                                        data={patientsList}
                                        onChange={(e) => handleOnChange(e, "acdd", "clientName")}
                                        key={newVisit.client}
                                        onChangeSearch={(keyword, setData) => loadPatientsList(keyword, setData)}
                                        excludeColumns={[]}
                                        columns={patientDropdownColumns}
                                        deleteEnable={false}
                                        searchTableEnable={false}
                                        showTableOptionOnSelect={true}
                                        placeholder={"Πληκτρολογίστε και επιλέξτε ασθενή"}
                                        required={true}
                                        showInsertAddButton={true}
                                        hideSaveButton={true}
                                        hideInsertNewRow={true}
                                        inputFieldClasses="form-control"
                                        isPayrollCombobox={true}
                                        disabled={patientSelected}
                                    />
                                </Col>
                                <Col md={1}>
                                    {patientSelected ? (
                                        <Button title="Καθαρισμός πεδίου ασθενή" size={"sm"} onClick={() => handleResetNewVisit()} style={{marginTop: "28px"}}>Καθαρισμός</Button>
                                    ) : (
                                        <div style={{paddingTop: "23px"}}><NewClientModal fromPrescription={true} successCallback={(data) => hookNewPatient(data)} /></div>
                                    )}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    {Object.keys(newVisitSelectedClient).length > 0 && (
                        <React.Fragment>
                            <div className={"mb-3 borderedContainer"}>
                                <h5 style={{fontWeight: "600"}}>Πληροφορίες Ασθενή</h5>
                                <Row className={"mb-2"}>
                                    <Col md={3}>
                                        <Input
                                            label={"Ημερομηνία Γέννησης"}
                                            value={moment(newVisitSelectedClient.patientData.birthDate, "YYYYMMDD").format("DD/MM/YYYY")}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            label={"Οδός/Αριθμός"}
                                            value={newVisitSelectedClient.address}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            label={"Πόλη"}
                                            value={newVisitSelectedClient.city}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            label={"Ταχ. Κώδικας"}
                                            value={newVisitSelectedClient.postalCode}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                                <Row className={"mb-2"}>
                                    <Col md={3}>
                                        <Input
                                            label={"Τηλέφωνο"}
                                            value={newVisitSelectedClient.phone}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            label={"Φύλο"}
                                            value={newVisitSelectedClient.patientData.sex.id === "1" ? "Άρρεν" : "Θήλυ"}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Input
                                            label={"Άυλη Συνταγογράφηση"}
                                            value={newVisitSelectedClient?.noPaperConstent === "true" ? "Ναι" : "Όχι"}
                                            disabled={true}
                                        />
                                    </Col>
                                </Row>
                                <Row className={"mb-2"}>
                                    <Col md={12}>
                                        <Button size={"sm"} onClick={() => setShowBiometrics(true)}>Βιομετρικά</Button>
                                        <Button size={"sm"} onClick={() => setShowPatientDetails(true)} className={"ml-1"}>Δεδομένα ασθενη (ΗΔΙΚΑ)</Button>
                                        <Button size={"sm"} onClick={() => handleOpenPatientHistory()} className={"ml-1"}>Προβολή ιστορικού ασθενή</Button>
                                        {checkPermission("clients-clients/edit-cloud-read", permissionsData) === true && (
                                            <Button size={"sm"} onClick={() => handleOpenPatientCloud()} className={"ml-1"}>Προβολή αποθηκευμένων αρχείων ασθενή</Button>
                                        )}
                                    </Col>
                                </Row>
                                <VisitContactPoints clientData={newVisitSelectedClient} setClientData={(data) => {dispatch(setNewVisitSelectedClient(data))}} />
                                {(!isEmpty(newVisitSelectedClient?.patientData?.lastPrescriptionDate) || !isEmpty(newVisitSelectedClient?.patientData?.myLastVisitDate)) && (
                                    <Row>
                                        <Col md={12}>
                                            <Alert variant={"info"} className={"mb-1"}>
                                                {newVisitSelectedClient?.patientData?.lastPrescriptionDate && (
                                                    <span><strong>Ημερομηνία τελευταίας συνταγογράφησης:</strong> {newVisitSelectedClient.patientData.lastPrescriptionDate}<br/></span>
                                                )}
                                                {newVisitSelectedClient?.patientData?.myLastVisitDate ? (
                                                    <span><strong>Ημερομηνία τελευταίας επίσκεψης στο ιατρείο μου:</strong> {newVisitSelectedClient.patientData.myLastVisitDate}<br/></span>
                                                ) : (
                                                    <span><strong>Ο ασθενής δεν έχει επισκεφθεί το ιατρείο μου.</strong></span>
                                                )}
                                            </Alert>
                                        </Col>
                                    </Row>
                                )}
                                {!isEmpty(newVisitSelectedClient?.patientData?.myLastVisitDate) && (
                                    <React.Fragment>
                                        {moment().diff(moment(newVisitSelectedClient?.patientData?.myLastVisitDate, "DD/MM/YYYY HH:mm:ss"), "hours") <= 24 && (
                                            <Row>
                                                <Col md={12}>
                                                    <Alert variant={"danger"} className={"mb-0"}>
                                                        <strong>Προσοχή!</strong> Έχει πραγματοποιηθεί ήδη επίσκεψη με τον ίδιο ασθενή το τελευταίο 24ωρο.
                                                    </Alert>
                                                </Col>
                                            </Row>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>

                            <div className={"mb-3 borderedContainer"}>
                                <h5 style={{fontWeight: "600"}}>{newVisit.activeInsurances?.length === 1 ? "Ασφαλιστικός Φορέας Ασθενή" : "Ασφαλιστικοί Φορείς Ασθενή"}</h5>
                                {newVisit.activeInsurances?.length > 1 && (
                                    <span>
                                        Παρακαλώ επιλέξτε από την παρακάτω λίστα τον ασφαλιστικό φορέα με τον οποίο θα συνταγογραφήσετε.
                                    </span>
                                )}
                                <Row>
                                    <Col md={12}>
                                        {newVisit.activeInsurances?.length > 0 && (
                                            <React.Fragment>
                                                <table className={"simpleClassicTable"}>
                                                    <colgroup>
                                                        <col span={1} style={{width: "25%"}}></col>
                                                        <col span={1} style={{width: "20%"}}></col>
                                                        <col span={1} style={{width: "20%"}}></col>
                                                        <col span={1} style={{width: "25%"}}></col>
                                                        <col span={1} style={{width: "10%"}}></col>
                                                    </colgroup>
                                                    <thead>
                                                    <tr>
                                                        <th>Ασφ. Φορέας</th>
                                                        <th>Τύπος Μέλους</th>
                                                        <th>ΑΜΑ</th>
                                                        <th>Ημ/νια λήξης ασφαλιστικής ικανότητας</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {newVisit.activeInsurances.map((ins, idx) => (
                                                        <tr key={`insuranceTable-${idx}`}>
                                                            <td>{ins.socialInsurance.shortName}</td>
                                                            <td>{ins.memberType.name}</td>
                                                            <td>{ins.ama}</td>
                                                            <td>{moment(ins.expiryDate, "YYYY-MM-DD HH:mm:ss").isValid()
                                                                ? moment(ins.expiryDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")
                                                                : ins.expiryDate}</td>
                                                            <td>
                                                                {ins.erp_selected ? (
                                                                    <Badge bg={"success"}>
                                                                        Επιλεγμένος
                                                                    </Badge>
                                                                ) : (
                                                                    <Badge bg={"primary"} style={{cursor: "pointer"}} onClick={() => handleSelectInsurance(idx)}>
                                                                        Επιλογή
                                                                    </Badge>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                                {newVisit.activeInsurances.find((el) => el.erp_selected === true)?.canIssue === "false" && (
                                                    <Alert variant={"danger"} className={"mt-2 mb-0"}>
                                                        Δεν επιτρέπεται η συνταγογράφηση στον επιλεγμένο φορέα του ασθενή
                                                    </Alert>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </Col>
                                </Row>
                            </div>

                            <div className={"mb-3 borderedContainer"}>
                                <h5 style={{fontWeight: "600"}}>Πληροφορίες Επίσκεψης</h5>
                                <Row>
                                    <Col md={6}>
                                        <TextArea
                                            name={"cause"}
                                            label={"Λόγος Επίσκεψης"}
                                            rows={4}
                                            required={true}
                                            defaultValue={newVisit.cause}
                                            limit={2000}
                                            onChange={(e) => handleOnChange(e, "textarea", "cause")}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <TextArea
                                            name={"notes"}
                                            label={"Σημειώσεις"}
                                            rows={4}
                                            defaultValue={newVisit.notes}
                                            limit={2000}
                                            onChange={(e) => handleOnChange(e, "textarea", "notes")}
                                        />
                                    </Col>
                                </Row>
                            </div>

                            <BiometricsModal
                                show={showBiometrics}
                                setShow={setShowBiometrics}
                                amka={newVisitSelectedClient.amka}
                            />

                            <PatientDetailsModal
                                show={showPatientDetails}
                                setShow={setShowPatientDetails}
                                amka={newVisitSelectedClient.amka}
                                successfullCallback={(clientObject) => {
                                    dispatch(setNewVisitSelectedClient({...newVisitSelectedClient, ...clientObject}));
                                }}
                            />

                            <Modal show={patientNotificationsModal} onHide={() => setPatientNotificationsModal(false)} dialogClassName={"modal42PercentWidth"}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Ενημερώσεις σχετικά με τον ασθενή</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {patientNotifications.length > 0 && patientNotifications.map((msg) => (
                                        <div className={"borderedContainer mt-2"} style={{wordWrap: "break-word"}}>
                                            {linkify(msg)}
                                        </div>
                                    ))}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" onClick={() => setPatientNotificationsModal(false)}>
                                        Εντάξει
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal show={newVisitOverrideModal.show} onHide={() => handleCloseOverrideModal()}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Εξαίρεσεις</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {newVisitOverrideModal.text}
                                    <Dropdown
                                        name={"overrideReasonId"}
                                        label={"Λόγος εξαίρεσης"}
                                        options={newVisitOverrideOptions}
                                        defaultValue={newVisitOverrideOptions.find((el) => el.value === newVisitOverrideModal.overrideReasonId)}
                                        key={Math.random()}
                                        onChange={(e) => dispatch(setNewVisitOverrideModal({...newVisitOverrideModal, overrideReasonId: e.value}))}
                                    />
                                    <BetterCheckBox
                                        className={"mb-1"}
                                        name={"isChecked"}
                                        text={"Αποδοχή εξαίρεσης"}
                                        checked={newVisitOverrideModal.isChecked === "true"}
                                        onChange={(e) => dispatch(setNewVisitOverrideModal({...newVisitOverrideModal, isChecked: String(e.target.checked)}))}
                                    />
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="primary" onClick={() => handleSaveWithOverrides()} disabled={loadingPostWithOverride}>
                                        Τελική Καταχώρηση {loadingPostWithOverride && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        </React.Fragment>
                    )}
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default VisitNew
